export default __webpack_public_path__ + "static/media/profile-dashboard.256b3d96.png";